module.exports = __webpack_public_path__ + "static/img/11.e5afa35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/sp/11.png
// module id = ut4a
// module chunks = 0